import React, { useState } from "react";
import "./panel.scss";
import SiteTexts from "utils/Texts";
import { Labels } from "utils/Labels";
import TextInput from "components/Input/TextInput";
import { ErrorAboutUs } from "JsFunctions/Dashboard/AboutUs";
import TextEditor from "components/TextEditor/TextEditor";

interface Props {
  gotData: boolean;
  editAboutUsHandler: () => void;
  address: string;
  setAddress: React.Dispatch<React.SetStateAction<string>>;
  description: string;
  setDescription: React.Dispatch<React.SetStateAction<string>>;
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  fax: string;
  setFax: React.Dispatch<React.SetStateAction<string>>;
  phone: string;
  setPhone: React.Dispatch<React.SetStateAction<string>>;
  error: ErrorAboutUs;
}

const AboutUsMobilePage: React.FC<Props> = ({
  gotData,
  editAboutUsHandler,
  address,
  setAddress,
  description,
  setDescription,
  email,
  setEmail,
  fax,
  setFax,
  phone,
  setPhone,
  error,
}) => {
  const SiteText = SiteTexts();

  return (
    <>
      <div className="about-us-parent">
        <h4>{SiteText.ABOUT_US.TITLE}</h4>
        {gotData === true ? (
          <form onSubmit={editAboutUsHandler}>
            <div className="text-input-parent">
              <TextInput
                lable={Labels.InputLabels.Phone}
                className={"general-input" + (error.phone ? " error" : "")}
                error={error.phone}
                value={phone}
                required={true}
                name={"input-phone"}
                onChangeValue={setPhone}
                autoFocus={true}
                regex={""}
                type={"text"}
                removeLable={false}
              />
            </div>
            <div className="text-input-parent">
              <TextInput
                lable={Labels.InputLabels.Email}
                className={"general-input" + (error.email ? " error" : "")}
                error={error.email}
                value={email}
                required={true}
                name={"input-email"}
                onChangeValue={setEmail}
                autoFocus={false}
                regex={""}
                type={"text"}
                removeLable={false}
              />
            </div>
            <div className="text-input-parent">
              <TextInput
                lable={Labels.InputLabels.Fax}
                className={"general-input" + (error.fax ? " error" : "")}
                error={error.fax}
                value={fax}
                required={true}
                name={"input-fax"}
                onChangeValue={setFax}
                autoFocus={false}
                regex={""}
                type={"text"}
                removeLable={false}
              />
            </div>
            <div className="text-input-parent width100">
              <TextInput
                lable={Labels.InputLabels.Address}
                className={"general-input" + (error.address ? " error" : "")}
                error={error.address}
                value={address}
                required={true}
                name={"input-address"}
                onChangeValue={setAddress}
                autoFocus={false}
                regex={""}
                type={"text"}
                removeLable={false}
              />
            </div>
            <TextEditor
              setValue={setDescription}
              value={description}
              lable={Labels.InputLabels.Description}
              required={true}
              removeLable={false}
            />
            <div className="submit-search-input-parent">
              <button onSubmit={editAboutUsHandler}>
                {Labels.ButtonLabels.Edit_About_us}
              </button>
            </div>
          </form>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default AboutUsMobilePage;
